import { render, staticRenderFns } from "./StructuresSetting.vue?vue&type=template&id=06851fb7&"
import script from "./StructuresSetting.vue?vue&type=script&lang=js&"
export * from "./StructuresSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_Lavoro\\ALCYON\\Homestead\\code\\reporting\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06851fb7')) {
      api.createRecord('06851fb7', component.options)
    } else {
      api.reload('06851fb7', component.options)
    }
    module.hot.accept("./StructuresSetting.vue?vue&type=template&id=06851fb7&", function () {
      api.rerender('06851fb7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/settings/StructuresSetting.vue"
export default component.exports